// import React, { useEffect, useState } from 'react'
// import { useNavigate, useParams } from 'react-router-dom'
// import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
// import { Container, Row, Col } from 'react-bootstrap'
// import OtherService from '../services/Other'
// import Loader from '../component/Loader'
// import PrimaryGradientButton from '../component/PrimaryGradientButton'
// import YouTube from 'react-youtube'

// const VideoSingle = () => {
//   const { contentId } = useParams()
//   //All States
//   const [isVideo, setIsVideo] = useState([])
//   const [loading, setLoading] = useState(true);
//   const [noData, setNoData] = useState(false);
//   //All useEffect//
//   useEffect(() => {
//     const galleryImageResponse = async () => {
      
//       try {
//         const token = localStorage.getItem('access_token');
//         const galleryResponse = await OtherService.gallery(token,contentId);
//         if (galleryResponse.error == false) {
//           if (galleryResponse.data.videoDetails.length > 0) {
//             setIsVideo(galleryResponse.data.videoDetails[0].files);
//             setLoading(false)
//             setNoData(false)
//           }
//           else {
//             setLoading(false)
//             setNoData(true)
//           }

//         }
//         else {
//           setLoading(false)
//           setNoData(true)
//         }
//       }
//       catch (error) {
//         console.error('Error:');
//       }
//     }
//     galleryImageResponse()
//   }, [])
//   const navigate = useNavigate()
//   const handleBack = () => {
//     navigate(`/video-gallery`);
//   }
  
//   return (
//     <>
//       {loading && <Loader />}

//       <BreadCrumbSecttion
//         pageTitle="Video"
//         currentPageName="Video" />
//       <section className='padTop50'>
//         <Container>
//           <Row>
//             <Col xs={12}>
//               <div className='buttonWrap my-4'>
//                 <PrimaryGradientButton buttonText="Back" onClick={handleBack} />

//               </div>
//             </Col>
//           </Row>
//         </Container>
//         <Container>
//           <div className='userInfoBox'>
//             {noData &&
//               <Row>
//                 <Col><div className="noDataMsg">No data found!</div></Col>
//               </Row>
//             }
//             <Row>
//               {isVideo?.map((item) => {
//                 const { id, title, thumbnail_image, file_path } = item
//                 // Check if file_path is a YouTube URL
//                 const isYouTube = file_path.includes('youtu.be');
//                 //YouTube URL Extract
//                 // const start = file_path.indexOf('src="') + 5;
//                 // const end = file_path.indexOf('"', start);
//                 // const youtubeUrl = file_path.substring(start, end);
//                 const youtubeCode = file_path.split("youtu.be/")[1]
//                 const youtubeUrl = `https://www.youtube.com/embed/${youtubeCode}`
//                 console.log("youtubeUrl", youtubeUrl);
                
//                 return (
//                   <Col xs={12} lg={4} xxl={3} key={id} className='galleryImgBox VideoGallery'>
//                     <div className='itemWrap'>
//                       <div className='itemWrapImage'>
//                         {isYouTube && (
//                           <div className="embed-responsive embed-responsive-21by9">
//                             {/* <iframe className="embed-responsive-item" src={youtubeUrl}></iframe> */}
//                             <iframe className="embed-responsive-item" src={youtubeUrl} title="YouTube Video"allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"allowFullScreen/>
//                           </div>
//                         )}
//                         {!isYouTube && (
//                           <iframe className="embed-responsive-item" src={file_path}></iframe>
//                         )}
//                       </div>
//                       <div className="itemWrapImageTxt"><p>{title}</p></div>
//                     </div>

//                   </Col>
//                 )
//               })}

//             </Row>
//           </div>

//         </Container>
//       </section>
//     </>
//   )
// }

// export default VideoSingle


import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import { Container, Row, Col } from 'react-bootstrap'
import OtherService from '../services/Other'
import Loader from '../component/Loader'
import PrimaryGradientButton from '../component/PrimaryGradientButton'
import YouTube from 'react-youtube'

const VideoSingle = () => {

  const { contentId } = useParams()
  const navigate = useNavigate()

  // All States
  const [isVideo, setIsVideo] = useState([])
  const [loading, setLoading] = useState(true)
  const [noData, setNoData] = useState(false)

  // ----------------------------------------------------
  // Extract YouTube Video ID from API file_path URL
  // e.g. https://www.youtube.com/watch?v=1orXXuPzNmY
  //      https://youtu.be/1orXXuPzNmY
  //      https://www.youtube.com/embed/1orXXuPzNmY
  // ----------------------------------------------------
  const getYouTubeId = (url) => {

    if (!url) {
      return null
    }

    try {

      const youtubeMatch = url.match(
        /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([^?&/]+)/
      )

      if (!youtubeMatch) {
        console.log('No YouTube video ID found')
        return null
      }

      const videoId = youtubeMatch[1]

      console.log('YouTube Video ID:', videoId)

      return videoId

    } catch (error) {

      console.error(
        'Error extracting YouTube ID:',
        error
      )

      return null
    }
  }

  // ----------------------------------------------------
  // Get Gallery Data
  // ----------------------------------------------------
  useEffect(() => {

    const galleryImageResponse = async () => {

      try {

        const token = localStorage.getItem('access_token')

        const galleryResponse =
          await OtherService.gallery(
            token,
            contentId
          )

        console.log(
          'Gallery Response:',
          galleryResponse
        )

        if (galleryResponse.error === false) {

          if (
            galleryResponse.data &&
            galleryResponse.data.videoDetails &&
            galleryResponse.data.videoDetails.length > 0
          ) {

            // The API always returns every video in the gallery
            // spot, so pick the one matching the current contentId
            // instead of always taking the first one.
            const matchedVideo =
              galleryResponse.data.videoDetails.find(
                (video) =>
                  String(video.contentDetails?.id) ===
                  String(contentId)
              ) || galleryResponse.data.videoDetails[0]

            setIsVideo(matchedVideo.files)

            setLoading(false)
            setNoData(false)

          } else {

            setLoading(false)
            setNoData(true)

          }

        } else {

          setLoading(false)
          setNoData(true)

        }

      } catch (error) {

        console.error(
          'Error fetching gallery:',
          error
        )

        setLoading(false)
        setNoData(true)

      }

    }

    galleryImageResponse()

  }, [contentId])

  // ----------------------------------------------------
  // Back Button
  // ----------------------------------------------------
  const handleBack = () => {

    navigate('/video-gallery')

  }

  // ----------------------------------------------------
  // YouTube Player Options
  // ----------------------------------------------------
  const youtubeOptions = {

    width: '100%',
    height: '250',

    playerVars: {

      autoplay: 0,
      controls: 1,
      rel: 0,

      // YouTube privacy enhanced mode
      modestbranding: 1

    }

  }

  // ----------------------------------------------------
  // Render
  // ----------------------------------------------------
  return (

    <>

      {loading && <Loader />}

      <BreadCrumbSecttion
        pageTitle="Video"
        currentPageName="Video"
      />

      <section className="padTop50">

        {/* Back Button */}
        <Container>

          <Row>

            <Col xs={12}>

              <div className="buttonWrap my-4">

                <PrimaryGradientButton
                  buttonText="Back"
                  onClick={handleBack}
                />

              </div>

            </Col>

          </Row>

        </Container>


        {/* Videos */}
        <Container>

          <div className="userInfoBox">

            {/* No Data */}
            {noData && (

              <Row>

                <Col>

                  <div className="noDataMsg">
                    No data found!
                  </div>

                </Col>

              </Row>

            )}


            {/* Video List */}
            <Row>

              {isVideo?.map((item, index) => {

                const {
                  id,
                  title,
                  thumbnail_image,
                  file_path
                } = item


                // ----------------------------------------
                // Extract YouTube ID
                // ----------------------------------------
                const youtubeCode =
                  getYouTubeId(file_path)


                console.log(
                  'Video:',
                  title,
                  'ID:',
                  youtubeCode
                )


                return (

                  <Col
                    xs={12}
                    lg={4}
                    xxl={3}
                    key={`${id}-${index}`}
                    className="galleryImgBox VideoGallery"
                  >

                    <div className="itemWrap">


                      {/* Video */}
                      <div className="itemWrapImage">

                        {youtubeCode ? (

                          <YouTube
                            videoId={youtubeCode}
                            opts={youtubeOptions}
                            className="youtubePlayer"
                          />

                        ) : (

                          <div className="noDataMsg">
                            Invalid video
                          </div>

                        )}

                      </div>


                      {/* Title */}
                      <div className="itemWrapImageTxt">

                        <p>
                          {title}
                        </p>

                      </div>


                    </div>

                  </Col>

                )

              })}

            </Row>

          </div>

        </Container>

      </section>

    </>

  )

}

export default VideoSingle
